import { render, staticRenderFns } from "./u-footer-basic.vue?vue&type=template&id=394a2b27&scoped=true"
import script from "./u-footer-basic.vue?vue&type=script&lang=js"
export * from "./u-footer-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a2b27",
  null
  
)

export default component.exports